import type { CommerceHttpAdapter } from '../../client/CommerceHttpAdapter.js'
import type { CacheStrategy } from '../../workers/CacheStrategy.js'
import type { ShippingChoiceGroup, ShippingAddress, PickupPoint } from '../../types/index.js'

export class ShippingModule {
  constructor(
    private readonly http: CommerceHttpAdapter,
    private readonly cache: CacheStrategy
  ) {}

  /** Récupère les groupes de modes de livraison disponibles pour le panier en cours */
  getAvailableModes(): Promise<ShippingChoiceGroup[]> {
    return this.cache.execute(
      'shipping:modes',
      () => this.http.get<ShippingChoiceGroup[]>('/commerce/api/process/cart/shipping/modes'),
      'network-first'
    )
  }

  /** Sélectionne un mode de livraison */
  selectMode(shippingModeGuid: string): Promise<void> {
    return this.http.post('/commerce/api/process/cart/shipping/mode', { shippingModeGuid })
  }

  /** Met à jour l'adresse de livraison */
  setAddress(address: ShippingAddress): Promise<void> {
    return this.http.put('/commerce/api/process/cart/address/shipping', address)
  }

  /** Recherche des points relais à proximité */
  getRelayPoints(postalCode: string, countryCode = 'FR', shippingModeGuid?: string): Promise<PickupPoint[]> {
    const params = new URLSearchParams({ postalCode, countryCode })
    if (shippingModeGuid) params.set('shippingModeGuid', shippingModeGuid)
    const key = `shipping:relays:${postalCode}:${countryCode}:${shippingModeGuid ?? ''}`
    return this.cache.execute(
      key,
      () => this.http.get<PickupPoint[]>(`/commerce/api/process/shipping/relays?${params.toString()}`),
      'cache-first',
      10 * 60_000 // 10 minutes
    )
  }
}
